export default {
  bioInfo: [
    {
      id: 1,
      "logo-class": "fa fa-calendar",
      content: "9th April 1999",
    },
    {
      id: 2,
      "logo-class": "fa fa-phone",
      content: "+254 703 416 363",
    },
    {
      id: 3,
      "logo-class": "fa fa-envelope-o",
      content: "sheldonwelinga@gmail.com",
    },
    {
      id: 4,
      "logo-class": "fa fa-map-marker",
      content: "Nairobi, Kenya",
    },
  ],
  socialLinks: [
    {
      id: 1,
      "icon-class": "fa fa-facebook",
      link: "https://www.facebook.com/sheldon.welinga.9/",
    },
    {
      id: 2,
      "icon-class": "fa fa-twitter",
      link: "https://www.twitter.com/welinga_sheldon",
    },
    {
      id: 3,
      "icon-class": "fa fa-linkedin",
      link: "https://www.linkedin.com/in/sheldon-welinga/",
    },
  ],
  skills: [
    {
      professional: [
        "Frontend developer skills with HTML, CSS, Javascript with great understanding of modern  frameworks like ReactJs, Redux, Nextjs, Javascript, Typescript, JQuery, Boostrap, Material UI, Graphql Apollo & Relay ",
        "Backend skills using Nodejs, Nestjs, ExpressJs, TypeORM and databases like MongoDB, PostgreSQL and MySQL and Realtime database handling with Socket and Pusher",
        "Great understanding of Javascript core language concepts like DOM Manipulation, Fetch API and ES6 Features.",
        "Understanding of AWS EC2, Cloudfront and Nginx Server and SSL handling.",
        "Working knowledge of Git Version control tool.",
        "UI/UX Design using Figma.",
      ],
      bars: [
        {
          title: "HTML5",
          "bar-class": "html",
        },
        {
          title: "CSS3",
          "bar-class": "css",
        },
        {
          title: "JavaScript",
          "bar-class": "js",
        },
        {
          title: "ReactJs",
          "bar-class": "react",
        },
        {
          title: "NodeJs",
          "bar-class": "node",
        },
        {
          title: "PostgreSQL",
          "bar-class": "postgresql",
        },
        {
          title: "MySQL",
          "bar-class": "mysql",
        },
        {
          title: "MongoDB",
          "bar-class": "mongodb",
        },
      ],
    },
  ],
  experience: [
    {
      title: "Fullstack Javascript Developer, Gitstart",
      date: "Sept 2021 to Present",
      duties: [
        "Managing other developers and assisting in different UI integrations.",
        "Implementing both UI and API across different client instances.",
        "Ensuring standard codes and delivering by acting as final code reviewer.",
        "Implementing different CI/CD pipelines across different client instances.",
        "Managing different code bases and client instances.",
      ],
    },
    {
      title: "Fullstack Web Developer, Fleetsimplify",
      date: "Feb 2021 to Sept 2021",
      duties: [
        "Designing and creating the server-side and API’s for applications using Nodejs / NestJs.",
        "Handling the application on the AWS server and Nginx and ensuring the servers are always up and running.",
        "Designing and creating the ready application database using MongoDB.",
        "Integrating the server with the frontend applications build on ReactJs and also working on the frontend with Reactjs and Redux.",
        "Working hand in hand with other team leaders and frontend developers.",
        "Performing maintenance, debugging and testing the entire server which includes core application logic, database, data and security using becrypting methods and JWT Authentication.",
      ],
    },
    {
      title: "Fullstack Web Developer, Instadriver",
      date: "Feb 2021 to Sept 2021",
      duties: [
          "Designing and creating the server-side and API’s for applications",
          "Handling the application on the AWS EC2, Cloudfront, SSL, and Nginx",
          "Formulation of database schemas.",
          "Client-Server intergration.",
          "Working hand in hand with other team leaders and frontend developers.",
          "Performing maintenance, debugging, testing, and security",
      ],
    },
    {
      title: "Backend Web Developer, Asembo Softwares Ltd",
      date: "Feb 2020 to Jan 2021",
      duties: [
        "Designing and creating the server-side and API’s for web and mobile applications using Nodejs framework.",
        "Designing and creating the database for applications using PostgreSQL.",
        "Working hand in hand with team leader and frontend developers in integrating the server with client-side applications.",
        "Performing maintenance, debugging and testing the entire server which includes core application logic, database, data and security using bcrypt hash methods and JWT Authentication.",
        "Hosting of website applications using Safaricom’s c-panel.",
      ],
    },
    {
      title: "Software Web Developer, Pinedate Ventures",
      date: "Oct 2019 to Jan 2020",
      duties: [
        "Designing and creating the client-side interface with Reactjs.",
        "UX Web designing using Figma.",
        "Creating servers and databases using Node.js, PostgreSQL and MongoDB.",
        "Ensuring responsiveness of applications using Bootstrap and CSS Media Queries.",
        "Hosting of websites using Safaricom’s c-panel.",
      ],
    },
    {
      title: "Frontend Web Developer, Tutor",
      date: "Feb 2019 to March 2020",
      duties: [
        "Teaching and mentoring passionate junior developers in understanding principle coding concepts.",
        "Working with team in developing different front-end sites using HTML, CSS, JavaScript and React.js.",
        "Assisting in troubleshooting different issues during web development.",
      ],
    },
    {
      title: "Backend and Frontend Developer, Freelancer",
      date: "Jan 2018 to Dec 2018",
      duties: [
        "Building web projects using Reactjs and Redux tools.",
        "Building scalable backend APIs with Nodejs/ExpressJs, PostgreSQL and MongoDB.",
        "Assisting clients integrate the backend apis with the frontend applications.",
      ],
    },
  ],
  education: [
    {
      institution: "Jomo Kenyatta University of Agriculture and Technology",
      date: "Sept 2018 to Present",
      title: "Bsc. in Mathematics and Computer Science",
    },
    {
      institution: "Petanns Institute of Business Studies",
      date: "March to July 2018",
      title: "Certificate in Computer Packages, Distinction",
    },
    {
      institution: "Butere Boys High School",
      date: "2014 to 2017",
      title: "Kenya Certificate of Secondary Education, B Plain",
    },
    {
      institution: "Martin Luther Primary School",
      date: "2006 to 2013",
      title: "Kenya Certificate of Primary Education, 362 Marks",
    },
  ],
  certifications: [
    {
      institution: "HackerRank ",
      cert_id: "Credential ID A52139B80DE7",
      date: "Sept 2020. No Expiration",
      title: "Hackerrank Javascript(Basic) Certificate",
    },
    {
      institution: "HackerRank ",
      cert_id: "Credential ID CA8B825B7717",
      date: "Sept 2020. No Expiration",
      title: "Problem Solving (Basic) Certificate",
    },
  ],
  services: [
    {
      title: "Front End Website Development",
      "icon-class": "fa fa-code",
      description: [
        "I go from no-code to an in-demand Front End Design of customers websites using ReactJs frameworks or pure HTML5, CSS3 and Javascript. As the role takes into consideration users experience and function, i acertain both levels of graphic design and computer programming. After deelopment of the website, I also assist with the maintenance and upkeep of the website.",
        "As a creative web developer, I can also work with other software application team to achieve the desired business' digital goals. I am also a hands-on professional with strong knowledge of content management platforms, and an ability to translate the business needs into client-friendly functions that will expand the website's influence in our industry.",
      ],
    },
    {
      title: "Back End Development",
      "icon-class": "fa fa-tasks",
      description: [
        "As a backend developer, I am also responsible fo writing the server-side web services and APIs using NodeJs which are later used in the front-end applications; both web and mobile. I offer both the creation, maintaintance, testing and debugging of the entire back end. This includes core application logic, databases, data, security using becrypting methods and JWT Authentication and application intergration.",
        "I can also work closely with other backend engineers and team to ensure the system consistency, improve user experience and also troubleshoot and improve current backend applications and processes. I am knowledgeable, collaborative and motivated developer.",
      ],
    },
    {
      title: "Database Design",
      "icon-class": "fa fa-database",
      description: [
        "Worrying about your database design? Worry no more for i've got you covered. Possesing great skills in database design to build a stable and reliable database according to your company's needs. With assurance for both testing, improving and maintaining new and existing databases to help users retrieve data effectively.",
        "I posses great passion of also working with developers to ensure system consistency. With athearance and collaboration with administrators and clients, i believe in providing technical support and identify new requirements. I also posses great communication and organization skills with a problem-solution attitude.",
      ],
    },
    {
      title: "UI/UX Design",
      "icon-class": "fa fa-image",
      description: [
        "I believe in offering great user interaction on the web. Therefore, I have passion for illustrating design ideas using process flows, storyboards and also designing the graphical user interface elements like menus, tabs  e.t.c.",
        "Possesing design skills with use of Figma, I believe in a great design procedure. I believe that to be successful for such a role, you have to encourage team work and that remains my slogan everytime in designing.",
      ],
    },
  ],
  contacts: [
    {
      "icon-class": "fa fa-map-marker",
      info: "Nairobi, Kenya",
      moreInfo: "17170 - 00510, KE",
    },
    {
      "icon-class": "fa fa-mobile",
      info: "+254 703 416 363",
      moreInfo: "Mon to Fri 9am to 6pm",
    },
    {
      "icon-class": "fa fa-envelope-o",
      info: "sheldonwelinga@gmail.com",
      moreInfo: "Send me your query anytime!",
    },
  ],
};
